import { Provider } from "@angular/core";

import { QUERY_HUB } from "./query-hub.constants";
import { QueryHubService } from "../services/query-hub.service";


export const queryHubProvider: Provider = {
    useClass: QueryHubService,
    provide: QUERY_HUB,
}